// @mui/icons-material
import Timeline from "@mui/icons-material/Timeline";
import LocationCity from "@mui/icons-material/LocationCity";
import CloudUpload from "@mui/icons-material/CloudUpload";
import AccessTime from "@mui/icons-material/AccessTime";
import TrendingDown from "@mui/icons-material/TrendingDown";
import Folder from "@mui/icons-material/Folder";
import RoomIcon from "@mui/icons-material/Room";
import WarningIcon from "@mui/icons-material/Warning";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import HomeIcon from "@mui/icons-material/Home";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Home from "views/Home/Home.js";
import Patrimoine from "views/Patrimoine/Patrimoine";
import Maps from "views/Maps/Maps";
import Alertes from "views/Alertes/Alertes";
import ImportsDonnees from "views/ImportsDeDonnees/ImportsDonnees";
import PlanActions from "views/PlanActions/PlanActions";
import Bills from "views/Bills/Bills";
import Meters from "views/Meters/Meters";
import Markets from "views/Markets/Markets";
import Exports from "views/Exports/Exports";
import Utilisateurs from "views/Utilisateurs/Utilisateurs";
import Documents from "views/Documents/Documents";
import Analyses from "views/Analyses/Analyses";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SettingsIcon from '@mui/icons-material/Settings';
import Profile from "./views/MonCompte/Profil";
import Backoffice from "views/Backoffice/Backoffice";
import WifiIcon from '@mui/icons-material/Wifi';
import SpeedIcon from '@mui/icons-material/Speed';
import AssessmentIcon from '@mui/icons-material/Assessment';
import MBM from 'views/MBM/MBM';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import CEE from 'views/CEE/CEE';
import TestPage from "views/TestPage/TestPage";
import CPE from 'views/CPE/CPE';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import Vehicles from 'views/Vehicles/Vehicles';
import GEB from 'views/GEB/GEB';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import ComputerIcon from '@mui/icons-material/Computer';
import TestPagesankey from "views/TestPage/TestPagesankey";
import Flex from "views/Flex/Flex";
import { SmartGrid2 } from "components/CustomIcon/CustomIcon";
import GEIT from "views/GEIT/GEIT";

const locale = (navigator.language || navigator.userLanguage).includes("fr") ? "fr-FR" : (navigator.language || navigator.userLanguage);
console.log(locale);
// const locale = 'fr-FR';

const dashRoutes = [
  {
    path: "/home",
    name: "Home",
    icon: HomeIcon,
    component: Home,
    layout: "/admin",
    permission: ["mem_access"],
    memv2version: 0,
  },
  {
    path: "/geb",
    name: locale === 'fr-FR' ? "GEB" : "EBMS",
    icon: EnergySavingsLeafIcon,
    component: GEB,
    layout: "/admin",
    permission: ["mem_access","mbm_geb_access"],
    memv2version: 0,
    usertype: 1,
    option: 'geb',
  },
  // {
  //   path: "/geit",
  //   name: locale === 'fr-FR' ? "GEIT" : "MITM",
  //   icon: ComputerIcon,
  //   component: GEIT,
  //   layout: "/admin",
  //   // permission: ["mem_access","mitm_access"],
  //   memv2version: 0,
  //   // usertype: 1,
  //   option: 'mitm',
  // },
  {
    path: "/flex",
    name: "Flex",
    icon: SmartGrid2,
    component: Flex,
    layout: "/admin",
    permission: ["mem_access","mbm_flex_access"],
    memv2version: 0,
    usertype: 1,
    option: 'flex',
  },
  {
    path: "/maps",
    name: "Maps",
    icon: RoomIcon,
    component: Maps,
    layout: "/admin",
    permission: ["mem_access", "maps_access"],
    memv2version: 0,
    usertype: 1,
    option: 'maps',
  },
  {
    path: "/analyses",
    name: locale === 'fr-FR' ? "Analyses" : "Dashboard",
    icon: Timeline,
    component: Analyses,
    layout: "/admin",
    permission: ["mem_access", "analysis_access"],
    memv2version: 0,
  },
  {
    path: "/alertes",
    name:  locale === 'fr-FR' ? "Alertes et évènements" : "Alerts and events",
    icon: WarningIcon,
    component: Alertes,
    layout: "/admin",
    permission: ["mem_access", ["alerts_access","events_access"]],
    memv2version: 0,
    usertype: 1,
    option: ['alertes','events'],
  },
  {
    path: "/patrimoine",
    name: locale === 'fr-FR' ? "Patrimoine" : "Real estate",
    icon: LocationCity,
    component: Patrimoine,
    layout: "/admin",
    permission: ["mem_access", "realestate_access"],
    memv2version: 0,
  },
  {
    path: "/meters",
    name:  locale === 'fr-FR' ? "Compteurs" : "Meters",
    icon: SpeedIcon,
    component: Meters,
    layout: "/admin",
    permission: ["mem_access", "realestate_access"],
    memv2version: 0,
    usertype: 1,
    option: 'meters',
    // usertype: 1,
    // userdomain: 'besancon.fr',
  },
  {
    path: "/mbm",
    name: "IoT",
    icon: WifiIcon,
    component: MBM,
    layout: "/admin",
    permission: ["mem_access", "mbm_access"],
    memv2version: 0,
    usertype: 1,
    option: 'mbm',
  },
  {
    path: "/import",
    name: locale === 'fr-FR' ? "Imports de Données" : "Data import",
    icon: CloudUpload,
    component: ImportsDonnees,
    layout: "/admin",
    permission: ["mem_access", "data_read"],
    memv2version: 0,
    usertype: 1,
    option: 'import',
  },
  {
    path: "/bills",
    name: locale === 'fr-FR' ? "Factures" : "Bills",
    icon: AttachMoneyIcon,
    component: Bills,
    layout: "/admin",
    permission: ["mem_access", ["bills_access", "budget_access"]],
    memv2version: 0,
    usertype: 1,
    option: ['bills', 'budget']
    //usertype: 1,
    //userdomain: 'besancon.fr',
  },
  {
    path: "/actionplans",
    name: locale === 'fr-FR' ? "Plan d'actions" : "Action plans",
    icon: AccessTime,
    component: PlanActions,
    layout: "/admin",
    permission: ["mem_access", "actionplan_read"],
    memv2version: 2,
    usertype: 1,
    option: 'actionplans',
  },
  {
    path: "/markets",
    name: locale === 'fr-FR' ? "Groupements d'achat" : "Purchasing groups",
    icon: AttachMoneyIcon,
    component: Markets,
    layout: "/admin",
    permission: ["mem_access", "markets_access"],
    memv2version: 0,
    usertype: 1,
    option: 'markets',
  },
  {
    path: "/cee",
    name:  locale === 'fr-FR' ? "Gestion des CEE" : "CEE",
    icon: MenuBookIcon,
    component: CEE,
    layout: "/admin",
    permission: ["mem_access", "cee_access"],
    memv2version: 0,
    usertype: 1,
    option: 'cee',
  },
  {
    path: "/vehicles",
    name:  locale === 'fr-FR' ? "Véhicules" : "Vehicles",
    icon: DriveEtaIcon,
    component: Vehicles,
    layout: "/admin",
    permission: ["mem_access", "vehicles_access"],
    memv2version: 0,
    usertype: 1,
    option: 'vehicles',
  },
  // {
  //   path: "/cpe",
  //   name: "CPE",
  //   icon: AssessmentIcon,
  //   component: CPE,
  //   layout: "/admin",
  //   permission: ["mem_access"],
  //   memv2version: 0,
  //   usertype: 1,
  // },
  {
    path: "/exports",
    name: "Exports",
    icon: CloudDownloadIcon,
    component: Exports,
    layout: "/admin",
    permission: ["mem_access", "exports_read"],
    memv2version: 1,
    usertype: 1,
    option: 'exports',
  },
  {
    path: "/documents",
    name:  locale === 'fr-FR' ? "Documents" : "Files",
    icon: Folder,
    component: Documents,
    layout: "/admin",
    permission: ["mem_access", "ged_read"],
    memv2version: 1,
  },
  {
    path: "/utilisateurs",
    name:  locale === 'fr-FR' ? "Utilisateurs" : "Users",
    icon: PeopleAltIcon,
    component: Utilisateurs,
    layout: "/admin",
    permission: ["mem_access", "view_update"],
    memv2version: 0,
  },
  // {
  //   path: "/backoffice",
  //   name: "Configuration",
  //   icon: SettingsIcon,
  //   component: Backoffice,
  //   layout: "/admin",
  //   permission: ["mem_access"],
  //   memv2version: 0,
  //   usertype: 1,
  // },
  {
    path: "/user-profile",
    name:  locale === 'fr-FR' ? "Mon compte" : "My account",
    icon: AccountCircleIcon,
    layout: "/admin",
    component: Profile,
    permission: ["mem_access"],
    memv2version: 0,
  },
  // {
  //   path: "/testpage",
  //   name: "Test",
  //   icon: Timeline,
  //   component: TestPagesankey,
  //   layout: "/admin",
  //   permission: ["mem_access", "view_update"],
  //   memv2version: 0,
  // },

];
export default dashRoutes;
